"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const eventConstants_1 = require("../../../constants/eventConstants");
const styles_1 = __importDefault(require("../../../styles/styles"));
const button_1 = __importDefault(require("../../button/button"));
const useAppDispatch_1 = __importDefault(require("../../../hooks/useAppDispatch"));
const ticketForm_1 = __importDefault(require("../../ticketComponent/ticketForm"));
const modal_1 = __importDefault(require("../../modal/modal"));
const ticketTable_1 = __importDefault(require("../../ticketComponent/ticketTable"));
const ticketSlice_1 = require("../../../features/ticket/ticketSlice");
const useAppSelector_1 = __importDefault(require("../../../hooks/useAppSelector"));
const UserTickets = ({ user }) => {
    const dispatch = useAppDispatch_1.default();
    const [ticketDetailVisible, setTicketDetailVisible] = react_1.useState(false);
    const [viewTickets, setViewTickets] = react_1.useState(false);
    const { selectedTicket, ticketCount } = useAppSelector_1.default((state) => ({
        selectedTicket: state.ticket.selectedTicket,
        ticketCount: state.ticket.totalEntries,
    }));
    const onPageChange = (page) => {
        dispatch(ticketSlice_1.getTickets({ phone_number: user.phone_number, page }));
    };
    const showTicketDetails = ({ ticket }) => {
        dispatch(ticketSlice_1.setSelectedTicket(ticket));
        setTicketDetailVisible(true);
    };
    react_1.useEffect(() => {
        dispatch(ticketSlice_1.getTickets({ phone_number: user.phone_number }));
    }, [user.phone_number]);
    const switchButton = () => {
        return (react_1.default.createElement(button_1.default, { onPress: () => setViewTickets(!viewTickets), text: viewTickets ? 'Hide user tickets' : 'Display user tickets', eventName: eventConstants_1.TOGGLE_VIEW_USER_TICKETS }));
    };
    let content = react_1.default.createElement(react_1.default.Fragment, null);
    if (ticketCount) {
        content = (react_1.default.createElement(react_native_1.View, { style: styles_1.default.boxStyles },
            react_1.default.createElement(react_native_paper_1.Card.Title, { title: "User tickets", left: ({ size }) => react_1.default.createElement(react_native_paper_1.Avatar.Icon, { size: size, icon: "ticket" }), right: switchButton, titleStyle: styles_1.default.textColorBlack }),
            viewTickets && (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.marginTen] },
                react_1.default.createElement(ticketTable_1.default, { onTicketPress: showTicketDetails, onPageChange: onPageChange }))),
            react_1.default.createElement(modal_1.default, { title: "View Ticket", visible: ticketDetailVisible, hideModal: () => setTicketDetailVisible(false), containerStyle: styles_1.default.modelFormTop },
                react_1.default.createElement(ticketForm_1.default, { ticket: selectedTicket, readonly: !!selectedTicket }))));
    }
    return content;
};
exports.default = UserTickets;
